module.exports = __webpack_public_path__ + "static/media/Gotham-Bold.722c5f89.otf";